import React from 'react';
import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

interface DateTimeCellProps {
  eventDate: string | null | undefined;
}

export const DateTimeCell = React.memo(({ eventDate }: DateTimeCellProps) => {
  if (!eventDate) {
    return <>—</>;
  }

  const dateObj = dayjs(eventDate);

  return (
    <Stack justifyContent="center" alignItems="flex-start" sx={{ height: '100%', py: 0.5 }}>
      <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 500, lineHeight: 1.2 }}>
        {dateObj.format('DD/MM/YYYY')}
      </Typography>
      <Typography variant="caption" sx={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 500 }}>
        {dateObj.format('HH:mm')}
      </Typography>
    </Stack>
  );
});

DateTimeCell.displayName = 'DateTimeCell';
